<template>
  <div class="container mt-4">
    <h2>Documentation: TextField Component</h2>

    <p>
      The <code>TextField</code> component is an enhanced text input that supports:
      <strong>label</strong>, <strong>placeholder</strong>, <strong>error messages</strong>,
      <strong>tooltip</strong>, and <strong>clear button</strong>.
    </p>

    <h3>Example 1: Basic input with label and placeholder</h3>
    <TextField
        v-model="example1"
        label="Username"
        placeholder="Enter your username"
    />
    <p class="mt-2">Value: <strong>{{ example1 }}</strong></p>
    <pre class="p-2 bg-white text-dark">
      &lt;TextField
          v-model="example1"
          label="Username"
          placeholder="Enter your username"
      /&gt;
    </pre>

    <h3>Example 2: Required field with error</h3>
    <TextField
        v-model="example2"
        label="Email"
        placeholder="Enter email"
        required
        :error="example2 === '' ? 'This field is required' : ''"
    />
    <p class="mt-2">Value: <strong>{{ example2 }}</strong></p>
    <pre class="p-2 bg-white text-dark">
      &lt;TextField
          v-model="example2"
          label="Email"
          placeholder="Enter email"
          required
          :error="example2 === '' ? 'This field is required' : ''"
      /&gt;
    </pre>

    <h3>Example 3: Input with tooltip</h3>
    <TextField
        v-model="example3"
        label="Password"
        placeholder="Enter password"
        info-tooltip-label="Password must be at least 8 characters"
    />
    <p class="mt-2">Value: <strong>{{ example3 }}</strong></p>
    <pre class="p-2 bg-white text-dark">
      &lt;TextField
          v-model="example3"
          label="Password"
          placeholder="Enter password"
          info-tooltip-label="Password must be at least 8 characters"
      /&gt;
    </pre>

    <h3>Example 4: Clearable input</h3>
    <TextField
        v-model="example4"
        label="Search"
        placeholder="Enter text to search"
        clearable
    />
    <p class="mt-2">Value: <strong>{{ example4 }}</strong></p>
    <pre class="p-2 bg-white text-dark">
      &lt;TextField
          v-model="example4"
          label="Search"
          placeholder="Enter text to search"
          clearable
      /&gt;
    </pre>

    <h3>Example 5: Disabled and readonly fields</h3>
    <TextField
        v-model="example5"
        label="Disabled Field"
        placeholder="You cannot edit this"
        disabled
    />
    <TextField
        v-model="example6"
        label="Read-only Field"
        placeholder="Read only"
        readonly
        class="mt-2"
    />
    <p class="mt-2">Values: <strong>{{ example5 }}</strong>, <strong>{{ example6 }}</strong></p>
    <pre class="p-2 bg-white text-dark">
      &lt;TextField
          v-model="example5"
          label="Disabled Field"
          placeholder="You cannot edit this"
          disabled
      /&gt;

      &lt;TextField
          v-model="example6"
          label="Read-only Field"
          placeholder="Read only"
          readonly
          class="mt-2"
      /&gt;
    </pre>
  </div>
</template>

<script>
import TextField from "@/components/common/text-field/TextField.vue";

export default {
  name: 'TextFieldDocumentation',
  components: {
    TextField
  },
  data() {
    return {
      example1: '',
      example2: '',
      example3: '',
      example4: '',
      example5: 'Cannot edit',
      example6: 'Read only'
    }
  }
}
</script>

<style scoped>
h2 {
  margin-bottom: 1rem;
}
h3 {
  margin-top: 1.5rem;
}
.container p {
  margin-bottom: 0.5rem;
}
pre {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>